export enum authType {
  logIn,
  signUp
}
